import { Model } from "./model";
import { Observers } from "./observers";
import { ArticleModel, Domrefs } from "./types";
import * as HELPERS from "./helpers";

export default async (root, parameters, services) => {
  const Domrefs = HELPERS.getDOMRefs();
  const observers = new Observers(Domrefs);
  const model = new Model(observers);
  // Utility variables for `requestAnimationFrame`
  let rafId: number | undefined = undefined;
  let rafActive = false;
  const isMobile = ('ontouchstart' in document.documentElement && /mobi/i.test(navigator.userAgent));

  if(!isMobile) {
    document.body.classList.add("desktop")
    model.isDesktop = true;
  }

  const allImages = Array.from(document.querySelectorAll(".background-image"))
  let imagesLoaded = 0;
  const loadImage = async (element: HTMLElement | null) => {
    if(!element) return

    function createLoader (image){
      if(!element) return
      const firstImageUrl = element.dataset.src
      if(!firstImageUrl) return;

      return new Promise(function(resolve, reject) {
      
        image.onload = async function(){ 
          element.style.backgroundImage =  "url('" + firstImageUrl + "')"
          imagesLoaded++
          if(imagesLoaded === allImages.length) {
            console.log("all imgs loaded");
          }
          resolve("Stuff worked!");
          };
      
        image.src    = firstImageUrl
      });

    }
    const a = await createLoader(new Image())
    return a
  }

  await loadImage(document.querySelector(".background-image"))
  window.setTimeout(() => {
    allImages.forEach((e,i) => {
      if(i === 0) return;
      loadImage(e as HTMLElement)
    })
  } , 1000)





 
  let animProgresses = {};

  if (Domrefs.TEKSTILAATIKOT) {
    const callbackForTextboxChange = (textbox: HTMLElement) => {
      model.changeVisibleTextbox(textbox);
    };
    const intersectionObserver = HELPERS.createIntersectionObserver(
      callbackForTextboxChange
    );
    for (let index = 0; index < Domrefs.TEKSTILAATIKOT.length; index++) {
      intersectionObserver.observe(Domrefs.TEKSTILAATIKOT[index]);
    }
  }

  return 
  // rest of this file is obsolete
};
